import CoverageOptionsStep from "components/steps/CoverageOptionsStep";

const Step11Page = () => <CoverageOptionsStep />;

export default Step11Page;
